<template>
  <div class="row justify-content-center">
    
    <div class="col-sm-12">

      <PreviewForm v-bind="programmePreview" v-if="programme" entity="programme" @on-pool="gotParticipants" :withSubmit="false"></PreviewForm>
      
      <div class="events mt-5">
        <tabs type="primary">
          <tab-pane :label="event.title" v-for="(event, index) in programmePreview.events" :key="index">
            <PreviewForm v-bind="event" entity="event" :participants_pool="programme.participants_pool" :withSubmit="false"></PreviewForm>
          </tab-pane>
        </tabs>
      </div>
    </div>
    
  </div>
</template>
<script>
import { DynamicForm, PreviewForm, Tabs, TabPane, Collapse, CollapseItem } from "src/components";
import {Tooltip} from 'element-ui'

export default {
  components: {
    PreviewForm,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Tooltip.name]: Tooltip,
    Collapse,
    CollapseItem
  },
  props: {
    programme: {
      type: Object,
      default: () => null
    },
    batches: Array
  },
  computed:{
    programmePreview(){
      let prgm = Object.assign({}, this.programme)
      prgm.events = []

      let batches = []
      prgm.batches.forEach((batch, index) => {
          batches.push(this.batches[batch])
      })
      prgm.batches = batches

      this.programme.events.forEach((event) => {
        let ev = Object.assign({}, event)
        let batches = []
        ev.batches.forEach((batch, index) => {
            batches.push(this.batches[batch])
        })
        ev.batches = batches
        prgm.events.push(ev)
      })
      
      return prgm
    }
  },
  data() {
    return {
      model: {
        participants_pool: []
      }
    };
  },
  methods: {
    formattedDate(cellValue, withTime = true){
      if(!cellValue)
        return '--';
      var d = new Date(cellValue);
      var options = (withTime) ? { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' } : { year: 'numeric', month: 'long', day: 'numeric' }
      return  d.toLocaleDateString('en-US', options); 
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit('on-validated', res, this.model);
        return res;
      });
    },
    gotParticipants(pool){
      this.model.participants_pool = pool
      // Note:- Work around for this.programme.participants_pool = pool
      // Vue is not reactive for such changes
      // https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats
      // Vue does not allow dynamically adding new root-level reactive properties to an already created instance.
      // However, it’s possible to add reactive properties to a nested object using the Vue.set(object, propertyName, value) 
      this.$set(this.programme, 'participants_pool', pool)
    },
  }
};
</script>
<style lang="scss">

</style>
